module.exports = __webpack_public_path__ + "img/logo.ae62053a.png";